export default __webpack_public_path__ + "ui/assets/img/mobile-cash-desk-20.svg";